import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { AddWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';

const BankTransfer = ({ amount, resetAll, details }) => {
  const [form] = Form.useForm();
  const { userDetails } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const params = {
        userId: userDetails?._id,
        amount: Number(amount),
        withdrawalMethod: 1,
        ...values
      };

      const { data } = await AddWithdrawRequestApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form?.resetFields();
        resetAll();
      }
    } catch (error) {
      if (error?.response?.data?.error?.message)
        toast.error(error?.response?.data?.error?.message);
    } finally {
      setIsLoading(false);
    }
  }

  const bankOptions = details?.map(bank => ({
    label: `${bank?.bankName} - ${bank?.fullName} (${bank?.bankAccountNumber})`,
    value: bank?.id,
  }));

  const handleBankChange = (bankId) => {
    const bankData = details?.find(d => d?.id === bankId);
    if (bankData) {
      form.setFieldsValue(bankData);
      setSelectedBank(bankId);
    }
  }

  useEffect(() => {
    if (details && details?.length > 0) {
      form.setFieldsValue(details[0]);
      setSelectedBank(details[0]?.id);
    } else {
      form.resetFields();
    }
  }, [details]);

  return (
    <div>
      <Form form={form} layout="vertical" className='space-y-5' onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 gap-5">

          {details?.length > 1 && (
            <Form.Item label={<span className="text-lg text-gray-500 font-medium">Select Bank Detail</span>}>
              <Select value={selectedBank} onChange={handleBankChange} options={bankOptions} />
            </Form.Item>
          )}

          <Form.Item
            name="bankName"
            label={<span className="text-lg text-gray-500 font-medium">Bank Name</span>}
            rules={[{ required: true, message: 'Please enter bank name' }]}
          >
            <Input placeholder="Bank name" size='large' />
          </Form.Item>

          <Form.Item
            name="fullName"
            label={<span className="text-lg text-gray-500 font-medium">Account Holder Name</span>}
            rules={[{ required: true, message: 'Please enter account holder name' }]}
          >
            <Input placeholder="Account holder name" size='large' />
          </Form.Item>

          <Form.Item
            name="bankAccountNumber"
            label={<span className="text-lg text-gray-500 font-medium">Account Number</span>}
            rules={[{ required: true, message: 'Please enter account number' }]}
          >
            <Input type='number' placeholder="Account number" size='large' />
          </Form.Item>

          <Form.Item
            name="ifscCode"
            label={<span className="text-lg text-gray-500 font-medium">IFSC Code</span>}
            rules={[{ required: true, message: 'Please enter ifsc code' }]}
          >
            <Input placeholder="IFSC code" size='large' />
          </Form.Item>

          <Form.Item
            name="iban"
            label={<span className="text-lg text-gray-500 font-medium">IBAN Code</span>}
            rules={[{ required: true, message: 'Please enter iban code' }]}
          >
            <Input placeholder="IBAN code" size='large' />
          </Form.Item>

          <Form.Item
            name="swifT_BIC_Code"
            label={<span className="text-lg text-gray-500 font-medium">Swift Code</span>}
            rules={[{ required: true, message: 'Please enter Swift Code' }]}
          >
            <Input placeholder="Swift code" size='large' />
          </Form.Item>

          <Form.Item
            name="bankBranchAddress"
            label={<span className="text-lg text-gray-500 font-medium">Bank Branch Address</span>}
            rules={[{ required: true, message: 'Please enter bank branch address' }]}
          >
            <Input placeholder="Bank branch address" size='large' />
          </Form.Item>
        </div>

        <Form.Item
          name='conditions'
          valuePropName="checked"
          rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
        >
          <Checkbox className='mt-4'>
            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
          </Checkbox>
        </Form.Item>

        <LoadableButton
          className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
          type="submit"
          lable='Submit'
          isLoading={isLoading}
          loadingLable='Adding request...'
        />
      </Form>
    </div>
  )
}

export default BankTransfer


